import PropTypes from 'prop-types';
import React from 'react';
import TruncateMarkup from 'react-truncate-markup';
import Style from './style.scss';
import Cx from 'classnames';
import C_A from '../../constants/analytics';
import { StyledToolboxIcon } from '../utils/Styled/title';
import { getContrastWhiteBlack } from '../../utils/helpers';
import styled from 'styled-components';
import DynamicLink from '../utils/DynamicLink';
import C from '../../constants/serviceCatalog';
import { getNavigationProps } from '../utils/DynamicLink/linkHelper';

const StyledItem = styled.div`
  border: solid 1px ${(props) => props.theme.borderColor};
  &.rectangle:hover {
    background-color: ${(props) => props.theme.hoverColor};
    border: solid 1px ${(props) => props.theme.brandColor};

    .iconIssue,
    .title,
    .description,
    .footer {
      color: ${(props) => getContrastWhiteBlack(props.theme.hoverColor)};
    }
  }
  &.hasChildren:after {
    border: solid 1px ${(props) => props.theme.borderColor};
  }
  &.hasChildren:hover:after {
    border-left: solid 1px ${(props) => props.theme.brandColor};
  }
  &.hasChildren:before {
    border: solid 1px ${(props) => props.theme.borderColor};
  }
  &.hasChildren:hover:before {
    border-right: solid 1px ${(props) => props.theme.brandColor};
  }
  .title {
    color: ${(props) => props.theme.headlineColor};
  }
  .description {
    color: ${(props) => props.theme.textColor};
  }
  .footer {
    color: ${(props) => props.theme.textColorLighten};
  }
  .contentsItem.contentsItem {
    border-color: ${(props) => props.theme.brandColor};
  }
  .iconIssue {
    color: ${(props) => props.theme.brandColor};
  }
`;
const StyledSimpleLink = styled.div`
  color: ${(props) => props.theme.brandColor};
  text-decoration: underline;
  &:hover {
    color: ${(props) => props.theme.brandColorDarken};
  }
`;

class ScItem extends React.Component {
  render() {
    let styleClass = '';
    let footer = null;
    let content;
    let activeLink = null;
    let itemsCaption;
    if (this.props.children) {
      styleClass = 'hasChildren';
      itemsCaption =
        this.props.children.length === 1
          ? this.props.intlObject['ssp.toolbox.Item']
          : this.props.intlObject['ssp.toolbox.Items'];
      if (
        this.props.children.length === 1 &&
        !this.props.children[0].children &&
        this.props.children[0].type != 'FAQ_ITEM' &&
        this.props.children[0].type != 'REFERENCE'
      ) {
        const link = this.props.children[0];
        const navigation = getNavigationProps(link.id);
        const target = link.openingMethod === C.NEW_WINDOW ? '_blank' : '_self';
        activeLink = (
          <DynamicLink
            className={Style.textLink}
            to={link.targetUrl || navigation[link.type]}
            target={target}
          >
            <StyledSimpleLink>{link.name}</StyledSimpleLink>
          </DynamicLink>
        );
      }
      footer = (
        <div
          className={Cx(Style.footer, 'footer')}
        >{`${this.props.children.length} ${itemsCaption}`}</div>
      );
      content =
        this.props.description && this.props.description.trim().length > 0 ? (
          <TruncateMarkup lines={4}>
            <div>{this.props.description}</div>
          </TruncateMarkup>
        ) : (
          <TruncateMarkup lines={4}>
            <div className={Style.truncateMarkup}>
              {activeLink}
              {this.props.children.length > 1 &&
                this.props.children.map((item, index) => {
                  return (
                    <span
                      key={index}
                      className={Cx(Style.contentsItem, 'contentsItem')}
                      title={
                        item.name ||
                        this.props.intlObject[`ssp.toolbox.${item.type}`]
                      }
                    >
                      {" "}
                      {item.name ||
                        this.props.intlObject[`ssp.toolbox.${item.type}`]}
                    </span>
                  );
                })}
            </div>
          </TruncateMarkup>
        );
    } else {
      content = (
        <TruncateMarkup lines={4}>
          <div>{this.props.description}</div>
        </TruncateMarkup>
      );
      let footerArr = [];
      let voteCaption, viewCaption;
      if (0 === this.props.votes || this.props.votes) {
        voteCaption =
          this.props.votes === 1
            ? this.props.intlObject['ssp.toolbox.Vote']
            : this.props.intlObject['ssp.toolbox.Votes'];
        footerArr.push(`${this.props.votes} ${voteCaption}`);
      }
      if (0 === this.props.views || this.props.views) {
        viewCaption =
          this.props.views === 1
            ? this.props.intlObject['ssp.toolbox.View']
            : this.props.intlObject['ssp.toolbox.Views'];
        footerArr.push(`${this.props.views} ${viewCaption}`);
      }
      if (footerArr.length) {
        footer = (
          <div className={Cx(Style.footer, 'footer')}>
            {footerArr.join(',')}
          </div>
        );
      }
    }
    let iconClass = '';

    let iconStyle = {};
    if (this.props.customIcon || C.SYSAI_CHATBOT_SC_ID === this.props.id) {
      iconClass = '';
      iconStyle.backgroundImage = `url(${this.props.iconPath})`;
      iconStyle.backgroundRepeat = 'no-repeat';
      iconStyle.backgroundPosition = 'top center';
      iconStyle.backgroundSize = '57px';
    } else if (this.props.uniqueName) {
      iconClass = `toolbox_${this.props.uniqueName}Icon`;
    } else {
      iconClass = `toolbox_${this.props.type.toLowerCase()}Icon`;
    }

    return (
      <div
        className={Style.itemWrapper}
        onClick={() =>
          this.props.reportAnalytics([
            C_A.TOOLBOX_ITEMS,
            C_A.CLICK,
            this.props.type
          ])
        }
      >
        <StyledItem
          className={Cx(
            Style.rectangle,
            'rectangle',
            Style.hasChildren,
            styleClass
          )}
        >
          <div className={Style.icon} style={iconStyle}>
            <StyledToolboxIcon
              className={Cx('iconIssue', Style[iconClass], iconClass)}
            />
          </div>
          <div className={Style.content}>
            <div
              className={Cx(Style.title, Style.wrap, 'title')}
              title={this.props.name}
            >
              {this.props.name}
            </div>
            <div
              className={Cx(Style.description, 'description')}
              title={this.props.description}
            >
              {content}
            </div>
            {footer}
          </div>
        </StyledItem>
      </div>
    );
  }
}

ScItem.propTypes = {
  name: PropTypes.string.isRequired,
  views: PropTypes.number,
  votes: PropTypes.number,
  id: PropTypes.number,
  type: PropTypes.string.isRequired,
  iconPath: PropTypes.string,
  uniqueName: PropTypes.string,
  systemItem: PropTypes.bool,
  customIcon: PropTypes.bool,
  description: PropTypes.string,
  intlObject: PropTypes.object.isRequired,
  reportAnalytics: PropTypes.func.isRequired,
  children: PropTypes.array
};
export default ScItem;



// WEBPACK FOOTER //
// ./components/ServiceCatalog/scItem.js